// types
import {
	Contract,
	DocumentCategory,
	DocumentType,
	ExpenseType,
	FunctionReturn,
	Transaction,
	User,
} from '../@types';

// props
export interface PostUploaderParams {
	category?: DocumentCategory;
	contract?: Contract;
	docType?: DocumentType;
	expenseType?: ExpenseType;
	file: File;
	onError?: (error: unknown) => void;
	onSuccess?: (res: FunctionReturn) => void;
	path?: string;
	transaction?: Transaction;
	user: User;
}

export const postUploader = async ({
	category,
	contract,
	docType,
	expenseType,
	file,
	onError,
	onSuccess,
	path: pathOverride,
	transaction,
	user,
}: PostUploaderParams): Promise<FunctionReturn> => {
	const token = sessionStorage.getItem('token');
	const formData = new FormData();

	let path = pathOverride ?? `bldtext/${user.id}`;

	if (!pathOverride) {
		if (transaction) {
			path += `/transactions/${transaction.id}`;

			if (expenseType && docType) {
				path += `/expense-type/${expenseType.id}/document-type/${docType.id}`;
			}
		} else if (contract) {
			path += `/contracts/${contract.id}`;
		}
	}

	formData.append('file', file, file.name);
	formData.append('path', path);
	formData.append('user', JSON.stringify(user));

	if (category) {
		formData.append('category', category);
	}

	if (contract) {
		formData.append('contract', String(contract.id));
	}

	if (docType) {
		formData.append('type', String(docType.id));
	}

	if (transaction) {
		formData.append('transaction', String(transaction.id));
	}

	try {
		const req = await fetch(`${process.env.REACT_APP_API_URL}/api/Uploader`, {
			method: 'POST',
			body: formData,
			headers: {
				Authorization: `Bearer ${token}`,
				apikey: process.env.REACT_APP_APIKEY || '',
			},
		});
		const res: FunctionReturn = await req.json();

		if (res.error) {
			if (onError) {
				onError(res.error);
			}

			return res;
		}

		if (onSuccess) {
			onSuccess(res);
		}

		return res;
	} catch (error) {
		if (onError) {
			onError(error);
		}

		return {};
	}
};
